import defaultSettings from '@/settings';

const title = defaultSettings.title || 'Vue Element Admin';

export default function getPageTitle(pageTitle) {
  return title;
  // if (pageTitle) {
  //   return pageTitle
  // }
  // return 'erp'
}
